export default "__VITE_ASSET__07581b37__"